module.exports = __webpack_public_path__ + "static/sc-07-3d1c8ce4c2a234c7374ce59d03044142.png";